export default __webpack_public_path__ + "static/media/spinner.180538fd.svg";